import { PauseCircleOutlined } from '@ant-design/icons';
import { message, Modal, Tooltip, Typography } from 'antd';
import {
  InfrastructureInstance,
  InfrastructureInstanceActionsEnum,
} from 'osep-generator-service-client-v1';
import { useState } from 'react';
import usePerformInfrastructureInstanceActionMutation from '../hooks/mutations/usePerformInfrastructureInstanceActionMutation';

type Props = {
  instance: InfrastructureInstance;
};

const DeprovisionInfraProjectInstanceButton = ({ instance }: Props) => {
  const { performInfrastructureInstanceAction } =
    usePerformInfrastructureInstanceActionMutation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setIsLoading(true);
    try {
      await performInfrastructureInstanceAction(instance.id, {
        action: InfrastructureInstanceActionsEnum.Deprovision,
      });
      setIsModalVisible(false);
      message.success(
        "We will deprovision the instance for you and notify you via email once it's ready.",
      );
    } catch (error) {
      message.error(
        `There was an error while deprovisioning the instance. Please try again or contact the OSEP team.`,
      );
      console.error('Error when deprovisioning instance:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Tooltip title={'Deprovision'}>
        <PauseCircleOutlined key="delete" onClick={showModal} />
      </Tooltip>
      <Modal
        title={'Deprovision Instance'}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={'Deprovision'}
        cancelText="Cancel"
        confirmLoading={isLoading}
      >
        <Typography.Paragraph>
          You are about to deprovision instance <b>{instance.name}</b>.
        </Typography.Paragraph>
        <Typography.Paragraph style={{ fontWeight: 'bold', color: 'red' }}>
          All infrastructure resources related to this instance will be
          shut-down and destroyed.
        </Typography.Paragraph>
        <Typography.Paragraph>
          The instance data will be retained and you can re-provision the
          instance later.
        </Typography.Paragraph>
      </Modal>
    </>
  );
};

export default DeprovisionInfraProjectInstanceButton;
